// libs
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/QuestionBody.module.scss'

const QuestionBody = ({ children, editing, isQuestionCollapsed }) => (
  <div className={classNames(style.container, !editing && style.readOnly, isQuestionCollapsed && style.collapsed)}>
    {children}
  </div>
)

QuestionBody.propTypes = {
  children: PropTypes.any,
  editing: PropTypes.bool,
  isQuestionCollapsed: PropTypes.bool
}

QuestionBody.displayName = 'QuestionBody'

export default QuestionBody
